import styled from 'styled-components'
import { useState, useEffect } from 'react';
import HomeMissionListItem from './homeMissionsListItem'

function HomeMissionList(props) {

  const Container = styled.div`
    max-width: 960px;
    margin: 0 auto;
    background: rgba(34, 51, 59, 0.1);
    border: 1px solid rgba(34, 51, 59, 0.1);
    display: flex;
    flex-direction: column;
    gap: 1px;
  `;

  const Loading = styled.div`
    text-align: center;
    padding: 32px 0;
    color: #7a8690;
    font-family: 'Rubik', sans-serif;
    font-size: 13px;
    text-transform: uppercase;
    letter-spacing: 0.18em;
  `;

  const Error = styled.div`
    text-align: center;
    padding: 32px 0;
    color: #6e2727;
    font-family: 'Rubik', sans-serif;
    font-size: 14px;
  `;

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      setHasError(false);
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/missions-today`,
        );
        const json = await res.json();
        setData(json);
      } catch (error) {
        setHasError(true);
      }
      setIsLoading(false);
    };
    fetchData();
  }, [setData]);

  if (hasError) {
    return <Error>Could not load today's missions.</Error>;
  }

  if (isLoading) {
    return <Loading>Loading…</Loading>;
  }

  return (
    <Container>
      {data.map(item => (
        <HomeMissionListItem
          key={item.Id}
          name={item.Name}
          descr={item.Description}
          date={item.Date}
          link={`/missions/${item.Id}`}
        />
      ))}
    </Container>
  );
}

export default HomeMissionList;
